import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TagVariant } from '@optimus-web/core';
import { TooltippedTag } from '@mews-commander/ui';
import { SmsUsaRegistrationStatus } from '@mews-commander/data-access';

interface CampaignRegistrationTagProps {
    registrationStatus: SmsUsaRegistrationStatus;
}

export const CampaignRegistrationTag = ({ registrationStatus }: CampaignRegistrationTagProps) => {
    const props = getCampaignRegistrationTagProps(registrationStatus);

    if (props == null) {
        return null;
    }

    const { textKey, variant, tooltip } = props;

    return (
        <TooltippedTag tooltip={tooltip} variant={variant}>
            <LocalizedText textKey={textKey} upperCase />
        </TooltippedTag>
    );
};

interface ComponentProps {
    textKey: Mews.TextKey;
    variant: TagVariant;
    tooltip?: React.ReactNode;
}

const getCampaignRegistrationTagProps = (status: SmsUsaRegistrationStatus): ComponentProps | undefined => {
    switch (status) {
        case SmsUsaRegistrationStatus.BrandRegistrationNone:
        case SmsUsaRegistrationStatus.BrandRegistrationPending:
        case SmsUsaRegistrationStatus.BrandRegistrationInReview:
        case SmsUsaRegistrationStatus.BrandRegistrationApproved:
        case SmsUsaRegistrationStatus.CampaignRegistrationPending: {
            return {
                textKey: TextKey.Pending,
                variant: 'basicSubtle',
                tooltip: <LocalizedText textKey={TextKey.SmsUsaCampaignRegistrationWaitingTimeMessage} />,
            };
        }
        case SmsUsaRegistrationStatus.CampaignRegistrationInProgress: {
            return {
                textKey: TextKey.InReview,
                variant: 'info',
                tooltip: <LocalizedText textKey={TextKey.SmsUsaCampaignRegistrationWaitingTimeMessage} />,
            };
        }
        case SmsUsaRegistrationStatus.CampaignRegistrationVerified: {
            return {
                textKey: TextKey.Approved,
                variant: 'success',
            };
        }
        case SmsUsaRegistrationStatus.BrandRegistrationSuspended:
        case SmsUsaRegistrationStatus.BrandRegistrationFailed: {
            return {
                textKey: TextKey.Pending,
                variant: 'basicSubtle',
            };
        }
        case SmsUsaRegistrationStatus.CampaignRegistrationFailed: {
            return {
                textKey: TextKey.Failed,
                variant: 'danger',
            };
        }
        case SmsUsaRegistrationStatus.CampaignRegistrationSuspended: {
            return {
                textKey: TextKey.Suspended,
                variant: 'danger',
            };
        }
        default: {
            return undefined;
        }
    }
};
